// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import { AuthProvider } from './contexts/AuthContext';
import { ColumnsProvider } from './contexts/ColumnsContext';
import { LoaderProvider } from './contexts/LoaderContext';
import DashboardLayout from "./Layout/DashboardLayout";
import Reporting from "./Pages/Reporting/Reporting";
import CallLogs from "./Pages/CallLogs/CallLogs";
import Register from "./Pages/Register/Register";
import Login from "./Pages/Login/Login";
import Users from "./Pages/Users/Users";
import Caps from "./Pages/Caps/Caps";
import ManualUpload from "./Pages/ManualUpload/ManualUpload";
import ManualRecordings from "./Pages/ManualRecordings/ManualRecordings";
import ConversionReport from "./Pages/Reports/ConversionReport";
import Analytics from "./Pages/Analytics/Analytics";
import VolumeAlerts from "./Pages/VolumeAlerts/VolumeAlerts";
import AskClaude from "./Pages/AskClaude/AskClaude";
import AsrComparison from "./Pages/AsrComparison/AsrComparison";
import ShadowComparison from "./Pages/ShadowComparison/ShadowComparison";
import ProtectedRoute from "./components/Route/ProtectedRoute";
import PublicRoute from "./components/Route/PublicRoute";
import { ToastContainer } from "react-toastify";
import Loader from "./components/Loader/Loader";
import "./App.css";

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={<Loader />} persistor={persistor}>
        <AuthProvider>
          <ColumnsProvider>
            <LoaderProvider>
              <Router>
                <Routes>
                  <Route
                    path="/login"
                    element={
                      <PublicRoute>
                        <Login />
                      </PublicRoute>
                    }
                  />
                  <Route
                    path="/register"
                    element={
                      <PublicRoute>
                        <Register />
                      </PublicRoute>
                    }
                  />
                  <Route path="/" element={<Navigate to="/reporting" replace />} />
                  <Route
                    path="/analytics"
                    element={
                      <ProtectedRoute>
                        <DashboardLayout>
                          <Analytics />
                        </DashboardLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/volume-alerts"
                    element={
                      <ProtectedRoute>
                        <DashboardLayout>
                          <VolumeAlerts />
                        </DashboardLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/reporting"
                    element={
                      <ProtectedRoute>
                        <DashboardLayout>
                          <Reporting />
                        </DashboardLayout>
                      </ProtectedRoute>
                    }
                  />
                  {/* Legacy path -> default to Ringba calls */}
                  <Route path="/callLogs" element={<Navigate to="/calls/ringba" replace />} />
                  <Route
                    path="/calls/ringba"
                    element={
                      <ProtectedRoute>
                        <DashboardLayout>
                          <CallLogs system="Ringba" />
                        </DashboardLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/calls/callgrid"
                    element={
                      <ProtectedRoute>
                        <DashboardLayout>
                          <CallLogs system="CallGrid" />
                        </DashboardLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/caps"
                    element={
                      <ProtectedRoute>
                        <DashboardLayout>
                          <Caps />
                        </DashboardLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/calls/manual-upload"
                    element={
                      <ProtectedRoute>
                        <DashboardLayout>
                          <ManualUpload />
                        </DashboardLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/calls/manual"
                    element={
                      <ProtectedRoute>
                        <DashboardLayout>
                          <ManualRecordings />
                        </DashboardLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/reports/conversion"
                    element={
                      <ProtectedRoute>
                        <DashboardLayout>
                          <ConversionReport />
                        </DashboardLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/users"
                    element={
                      <ProtectedRoute>
                        <DashboardLayout>
                          <Users />
                        </DashboardLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/ask-claude"
                    element={
                      <ProtectedRoute>
                        <DashboardLayout>
                          <AskClaude />
                        </DashboardLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/asr-comparison"
                    element={
                      <ProtectedRoute>
                        <DashboardLayout>
                          <AsrComparison />
                        </DashboardLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/shadow-comparison"
                    element={
                      <ProtectedRoute>
                        <DashboardLayout>
                          <ShadowComparison />
                        </DashboardLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                <ToastContainer
                  position="top-right"
                  autoClose={3000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  pauseOnHover
                  draggable
                  theme="colored" 
                />
              </Router>
            </LoaderProvider>
          </ColumnsProvider>
        </AuthProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;